import { render, staticRenderFns } from "./ElementsPanel.vue?vue&type=template&id=5b07e182"
import script from "./ElementsPanel.vue?vue&type=script&lang=js"
export * from "./ElementsPanel.vue?vue&type=script&lang=js"
import style0 from "./ElementsPanel.vue?vue&type=style&index=0&id=5b07e182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports